import { FeedbackDetails } from "../types/feedbackTypes";

export const feedbackInitialValues: FeedbackDetails = {
  name: "",
  text: "",
  captchaToken: "",
  file: {
    fileId: "",
    fileName: "",
    fileSize: 0,
    contentType: "",
    rootDirectory: "",
    relativePath: "",
    additionalMetadata: null,
  },
};
